var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinSolidLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6706 9.29146L14.7644 1.33166C14.3252 0.889447 13.6663 0.889447 13.2271 1.33166C12.7879 1.77387 12.7879 2.43719 13.2271 2.8794L13.4467 3.1005L7.07786 7.63317L3.56401 8.07538C2.46593 8.29648 1.47766 9.07035 1.14824 10.0653C0.818817 11.0603 1.03843 12.2764 1.80709 12.9397L5.65036 16.809L2.90517 19.5729C2.46593 20.0151 2.46593 20.6784 2.90517 21.1206C3.12478 21.3417 3.45421 21.4523 3.67382 21.4523C3.89344 21.4523 4.22286 21.3417 4.44248 21.1206L7.18767 18.3568L11.0309 22.2261C11.58 22.7789 12.2388 23 13.0075 23C13.3369 23 13.6663 23 13.8859 22.8894C14.984 22.5578 15.7527 21.5628 15.8625 20.4573L16.4115 16.9196L20.8038 10.6181L21.1333 10.9497C21.3529 11.1709 21.6823 11.2814 21.9019 11.2814C22.1215 11.2814 22.451 11.1709 22.6706 10.9497C23.1098 10.5075 23.1098 9.73367 22.6706 9.29146Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSolidLarge);
export default __webpack_public_path__ + "static/media/pin_solid_large.d8307b0bf571887c356accd6dd151e11.svg";
export { ForwardRef as ReactComponent };